import FileSaver from 'file-saver';
import { defineConfig } from '../config'
import { authHeader } from '../helpers';
import { utilsService } from './utils'
const { handleResponse } = utilsService

export const detectionService = {
  exportFile,
  importFile,
  create,
  update,
  deleteDetection,
  getAll,
  getPaginatedByRangeDate,
  getDistinctsByField,
  updateDetectionNewLead,
  getMediaOwnerToSendMediaSupplier,
  getBrandNameToSendSecretarialData,
  getAllItems,
  getItemById,
  deleteItem,
  createItem,
  updateItem,
  getAllAgentNameAndSurname,
  createAgent,
  getListOfBrandName,
  findAgentByFullName,
};

const { apiUrl, apiVer } = defineConfig.DETECTION_SERVICE;

function getApiPath() {
 return apiUrl + apiVer + "/detection"; 
}

function getAgentApiPath() {
  return apiUrl + apiVer + "/detection/agent"; 
}

function getAllItems(field) {
  const url = getApiPath() + `/${field.replace("_", "")}/all`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getItemById(field, id) {
  const url = getApiPath() + `/${field.replace("_", "")}/read/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}


function deleteItem(field, id) {
  const url = getApiPath() + `/${field.replace("_", "")}/delete/${id}`;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createItem(field, fieldValue) {
  const obj = {
    [field]: fieldValue
  };
  const url = getApiPath() + `/${field.replace("_", "")}/create`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(obj)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateItem(field, obj) {
  const url = getApiPath() + `/${field.replace("_", "")}/update`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(obj)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function findAgentByFullName(fullname) {
  const url = getAgentApiPath() + `/read/${fullname}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllAgentNameAndSurname() {
  const url = getAgentApiPath() + `/all/dto`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createAgent(agent) {
  const url = getAgentApiPath() + `/create`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(agent)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAll() {
  const url = getApiPath() + "/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getPaginatedByRangeDate(dateStart, dateEnd) {
  const url = getApiPath() + `/all/${dateStart}/${dateEnd}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getDistinctsByField(field) {
  const url = getApiPath() + `/all/distinct/${field}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function exportFile(startDate, endDate) {
  const url = getApiPath() + `/read/export/${startDate}/${endDate}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(response => {
      return response.blob()
    })
    .then(function (blob) {
      FileSaver.saveAs(blob, `export${startDate}${endDate}.xlsx`)
      return true;
    })
}

function importFile(file) {
  const url = getApiPath() + "/create/upload";
  const formData = new FormData();
  formData.append("file", file);

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function create(obj) {
  const url = getApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(obj)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function update(id, obj) {
  const url = getApiPath() + `/update/${id}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(obj)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteDetection(id) {
  const url = getApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateDetectionNewLead(id, obj) {
  const url = getApiPath() + `/update/newLead/${id}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(obj)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getMediaOwnerToSendMediaSupplier(mediaOwner) {
  const url = getApiPath() + `/read/mediaSupplier/${mediaOwner}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getBrandNameToSendSecretarialData(brandName) {
  const url = getApiPath() + `/read/secretarialData/${brandName}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getListOfBrandName(subject) {
  const url = getApiPath() + `/all/brand/${subject}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}